import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

type NewsItem = {
  id: number;
  day: string;
  month: string;
  year: string;
  title: string;
  description: string;
  images?: string[];
};
const renderDescriptionWithLinks = (text: string) => {
  const parts = text.split(/(info@hamdanoman\.com|http:\/\/www\.hamdanoman\.com\/)/g);

  return parts.map((part, index) => {
    if (part === "info@hamdanoman.com") {
      return (
        <a
          key={index}
          href="mailto:info@hamdanoman.com"
          className="text-blue-600 font-semibold hover:underline"
        >
          info@hamdanoman.com
        </a>
      );
    }

    if (part === "http://www.hamdanoman.com/") {
      return (
        <a
          key={index}
          href="http://www.hamdanoman.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 font-semibold hover:underline"
        >
          http://www.hamdanoman.com/
        </a>
      );
    }

    return <span key={index}>{part}</span>;
  });
};

const newsData: NewsItem[] = [
  {
    id: 1,
    day: "5",
    month: "June",
    year: "2016",
    title: "Hamdan Plaza Hotel - World Environment Day",
    description: `Every year June 5th is observed as World Environment Day. This year the team at Hamdan Plaza Hotel too joined in to observe this day by planting Saplings in the Gardens of the Property.`,
    images: [
      "/News/Picture01.jpg",
      "/News/Picture02.jpg",
      "/News/Picture04.jpg",
      "/News/Picture07.jpg",
      "/News/Picture09.jpg",
      "/News/Picture010.jpg",
      "/News/Picture011.jpg",
    ],
  },
  {
    id: 2,
    day: "1",
    month: "June",
    year: "2016",
    title: "Hamdan Group - Recruitment Notification",
    description: `Hamdan Group has been notified of fraudulent employment offers being made, via email, personal interview by imposters claiming them as Project Director, Project Manager etc. or other means of communication.
These fraudulent offers may instruct prospective candidates to provide detailed passport information, and/or to pay application and processing fees.

Hamdan Group has operations in Sultanate of Oman and in UAE. We do not operate in Malaysia where we have received complaints. We do not have any representative to hire candidates to any projects in Malaysia on behalf of Hamdan Group.

Hamdan Group does NOT require any payment or fees from prospective candidates.
Do not provide any personal / financial information whatsoever, or make any payments requested by any email or other means of communication requesting such data to secure employment with Hamdan Group.

Please note that these communications are fraudulent. They do not originate from Hamdan Group nor are they associated with Hamdan’s recruitment process.

To avoid recruitment fraud, please keep the following in mind:

Hamdan emails always end in "@hamdanoman.com.” Any email styled with “HAMDAN" using a different format is not genuine.
Hamdan website pages always begin with http://www.hamdanoman.com/ Any other format is not genuine.
Prior to employment offers, prospective employees are ALWAYS invited to an interview at Hamdan office or through registered recruitment firm office.
No money transfers or payments of any kind will EVER be requested by Hamdan as part of the recruitment process; or for immigration documents, insurance, or any other purpose.
No job offers will be made prior to a formal interview process from Hamdan HR Manager.

If you receive such a message, you are advised to contact info@hamdanoman.com`,
    images: ["/News/Recruitment Notification.jpg"],
  },
  {
    id: 3,
    day: "9",
    month: "July",
    year: "2015",
    title: "Hamdan Trading - Annual Iftar",
    description: `Hamdan Group, one of the largest corporate conglomerates from the Sultanate of Oman, has hosted its annual Iftar gathering in Salalah in celebration of the spirit of the Holy Month of Ramadan. The grand Iftar gathering was organised at Hamdan Plaza Hotel, as an expression of the company’s gratitude to its employees for their continuous support, and sharing a solid business relationship with them.

"I share my greetings and warm wishes to all fellow employees of Hamdan Group who are in love with the magnificent and peaceful country. I think there is no better way to celebrate and commemorate this than to do Iftar together with my fellow employees,

"said Hamdan's Vice Chairman Sheikh Abdullah Hamed Al Ghafri, as he welcomed distinguished guests.“Such Iftar parties will be organised in other parts of the Sultanate of Oman where Hamdan Group is having its business operations. Hosting Iftar is a noble work and we are doing it to give message of harmony to the society,” Sheikh Abdullah Hamed Al Ghafri said.

Hamdan Group invited all its employees for Annual Iftar Gathering from across its diversified business units in Salalah. Annual Iftar Gathering 2015 was attended by 250 plus employees on July 9, 2015. The gathering was hosted at Massa Hall, Hamdan Plaza Hotel, Salalah. Hamdan Group is part of one of the largest corporate conglomerates from the Sultanate of Oman. The group commenced its business operations in the year 1975 and has mirrored the growth of the Sultanate of Oman and contributed significantly to the Omani economy.

Today the group has more than fourteen well organized and diversified business units each establishing a benchmark in its own field. Hamdan Group consists of three core divisions Viz; Transport, Construction and Dunlop Agency.

The Transport Division is one of the largest and oldest in the Sultanate having the most diverse fleet. The most challenging and complex logistics requirements have been fulfilled by the division and has been awarded ISO certification.

The construction Division is engaged in large scale Civil and Private construction activities across the Sultanate. The Dunlop agency of Hamdan Trading Group is the sole distributor of Dunlop Tires across the Sultanate of Oman.

Hamdan Group officials Sheikh Abdullah Hamed Al Ghafri (Vice Chairman), Mr. Ammar Al Ghafri (Deputy Chief Executive Officer), Mr. Rajput (Chief Financial Officer & Managing Director) and Mr. Awadh Said Musallam Khawar (Technical Consultant) greeted the esteemed guests as the evening descended and the Iftar gathering started. They exchanged Ramadan greetings with all employees and community leaders.

Wrapping up the celebrations, Sheikh Abdullah Hamed Al Ghafri expressed appreciation to all the esteemed guests for making the day special with their presence. He said, “Ramadan is a perfect time to show our gratitude, especially to those who matter to us. I would like to express my gratitude to all our business stake holders and media friends; and we share our success to all of you.” `,
    images: ["/News/Annual-Iftar-1.jpg", "/News/Annual-Iftar-2.jpg"],
  },
  {
    id: 4,
    day: "6",
    month: "April",
    year: "2015",
    title: "Hamdan Transport - First Rig Move Oxy Contract",
    description: `Transport Division completed its first rig move to Oxy contract early this morning, R952 was moved successfully under a heavy audience of Oxy and Ensign.`,
    images: ["/News/MUK-001-2015-214.jpg", "/News/MUK-001-2015-222.jpg"],
  },
  {
    id: 5,
    day: "1",
    month: "April",
    year: "2015",
    title: "Dunlop Sales Promotion During April to June 2015",
    description: `Sales Promotion During April to June 2015 for our Dealers and cash customers all stores of Oman.`,
    images: ["/News/Scratch-Arabic.jpg", "/News/Scratch-English.jpg"],
  },
  {
    id: 6,
    day: "2",
    month: "Feb",
    year: "2015",
    title: "Hamdan Exchange - Opening of 16th at Quriyat in the Sultanate",
    description: `We have great pleasure in informing the grand opening of our 16th branch at Quriyat. The branch was inaugurated by H.E. Said Juma Salem Al Ghazal, Member of Consultant Council for Quriyat on Sunday, 1st February 2015 at 6.30 pm in the august presence of Dr Ali Al Ghafri, Regional Director and Mr Ammar Ahmed Al Ghafri, MD, Hamdan Exchange.`,
  },
  {
    id: 7,
    day: "23",
    month: "Nov",
    year: "2014",
    title: "Official holiday for National Day",
    description: `It has been declared by the government that the official holiday for the private sector for “Oman’s 44th National Day” will be from Wednesday, 26th November 2014 to Thursday, 27th November 2014 and work will resume on Sunday, 30th November 2014.

All employees not on essential duty are granted leave of absence from work during the official holiday period. Those are on essential duties will be compensated accordingly.

However, all employees not on essential duty who wish to move out of their station of posting during the holiday are required to inform the management so that their whereabouts are known.`,
  },
  {
    id: 8,
    day: "18",
    month: "Nov",
    year: "2014",
    title: "Oman National Day",
    description: `Hamdan Trading Group would like to express its congratulatory to His Majesty Sultan Qaboos bin Said of Oman for the country's National Day. We wish His Majesty Sultan Qaboos bin Said good health and more lives to come. We are grateful for the progress and prosperity of our Country.`,
  },
  {
    id: 9,
    day: "12",
    month: "Nov",
    year: "2014",
    title: "Hamdan Exchange’s branch in Liwa, its 15th in the sultanate",
    description: `Hamdan Exchange recently opened an outlet in Liwa, its fifteen in in the sultanate. It will offer several services including Xpress Money, Western Union, Trans-Fast services and inter-bank transfers.`,
  },
];

const News: React.FC<{ content?: any }> = ({ content }) => {
  const [activeImage, setActiveImage] = useState<string | null>(null);
  const { t_api } = useLanguage();

  const introTitle = t_api(content?.intro_title || "About • News", content?.intro_title_ar);
  const title = t_api(content?.title || "Latest News", content?.title_ar);
  const displayNews = content?.items && content.items.length > 0 ? content.items : newsData;

  return (
    <section className="bg-white" >
      <div className="max-w-7xl mx-auto px-6 py-10">
        {/* HEADER */}
        <div className="mb-14">
          <p className="text-xs font-semibold tracking-widest text-red-500 uppercase">
            {introTitle}
          </p>
          <h1 className="mt-3 text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight">
            {title}
          </h1>
        </div>

        {/* NEWS LIST */}
        <div className="space-y-16">
          {displayNews.map((item: any, index: number) => {
            // Adjust for potential different nested structure if coming from API
            const images = item.images?.map((img: any) => {
              const url = typeof img === 'string' ? img : img.url;
              return url && url.startsWith('/') && !url.startsWith('http') ? `https://hamdanoman.com/${url}` : url;
            }).filter(Boolean) || [];

            return (
              <div
                key={item.id || index}
                className="grid md:grid-cols-[90px_1fr] gap-8 items-start"
              >
                {/* DATE */}
                <div className="text-center">
                  <div className="text-2xl font-extrabold text-[#C1121F]">
                    {item.day}
                  </div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">
                    {t_api(item.month, item.month_ar)}
                  </div>
                  <div className="text-sm font-semibold text-gray-700">
                    {item.year}
                  </div>

                  {index !== displayNews.length - 1 && (
                    <div className="mx-auto mt-4 w-[2px] h-16 bg-yellow-500/30" />
                  )}
                </div>

                {/* CONTENT */}
                <div>
                  <h2 className="text-1xl md:text-2xl font-extrabold text-gray-900" >
                    {t_api(item.title, item.title_ar)}
                  </h2>

                  <p className="mt-4 text-justify text-[15px] sm:text-sm md:text-base text-gray-700 leading-relaxed whitespace-pre-line">
                    {renderDescriptionWithLinks(t_api(item.description, item.description_ar))}
                  </p>


                  {/* IMAGES – NO BACKGROUND */}
                  {images && images.length > 0 && (
                    <div className="mt-6 grid sm:grid-cols-3 md:grid-cols-4 gap-6">
                      {images.map((img: string, idx: number) => (
                        <img
                          key={idx}
                          src={img}
                          alt={item.title}
                          onClick={() => setActiveImage(img)}
                          className="w-full h-[200px] object-contain cursor-pointer hover:scale-105 transition-transform duration-300"
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* IMAGE PREVIEW MODAL */}
      {activeImage && (
        <div
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center"
          onClick={() => setActiveImage(null)}
        >
          {/* CLOSE BUTTON */}
          <button
            onClick={() => setActiveImage(null)}
            className="absolute top-6 right-6 text-white text-3xl font-bold hover:opacity-70 transition"
            aria-label="Close"
          >
            ✕
          </button>

          {/* IMAGE */}
          <img
            src={activeImage}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            className="max-w-[90%] max-h-[90%] object-contain rounded-md shadow-2xl"
          />
        </div>
      )}
    </section>
  );
};

export default News;
